module.exports = __webpack_public_path__ + "static/media/dailycheckin.ba68c33a.jpg";